import { useEffect, useState, useRef } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { CircleNotch, WarningCircle } from "@phosphor-icons/react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function Verify() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { login } = useAuth();
  const [error, setError] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = params.get("token");
    if (!token) {
      setError("Missing sign-in token.");
      return;
    }
    (async () => {
      try {
        const res = await api.post("/auth/verify", { token });
        login(res.data.token, res.data.user);
        navigate("/portal", { replace: true });
      } catch (err) {
        setError(err?.response?.data?.detail || "This link is invalid or expired.");
      }
    })();
  }, [params, login, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background grid-lines p-6">
      <div className="bg-card border border-border p-10 max-w-sm w-full text-center" data-testid="verify-card">
        {!error ? (
          <>
            <CircleNotch size={40} className="text-primary mx-auto animate-spin" />
            <p className="mt-6 font-mono text-xs tracking-[0.3em] uppercase text-muted-foreground">
              Verifying your link…
            </p>
          </>
        ) : (
          <>
            <WarningCircle size={40} className="text-primary mx-auto" />
            <h2 className="font-head text-2xl font-light mt-4 mb-2">Access denied</h2>
            <p className="text-sm text-muted-foreground font-light mb-6" data-testid="verify-error">{error}</p>
            <Link
              to="/login"
              className="inline-block font-mono text-xs tracking-widest uppercase border border-primary text-primary hover:bg-primary hover:text-primary-foreground px-6 py-3 transition-colors"
            >
              Back to sign in
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
